// typings

import { create } from "zustand";

import { IDownloadLoadState } from "@/store-zustand/admin/pegar-tarefas/index.d";

// criação da store com Zustand (baixar cargas)
export const useStoreZustandPegarTarefas = create<IDownloadLoadState>((set) => ({
  // estados
  isLoading: false,
  isLoadingPage: false,
  isModalPegarTarefas: false,
  downloadLoad: [],
  minhasTarefas: [],
  paginations: [1],
  itemsPerPage: 10,
  currentPage: 1,
  totalItemsPage: 0,
  searchItem: "",
  lastPage: 1,
  idRemessa: 0,
  tarefa: null,

  // ações
  setIsLoading: (isLoading) => set({ isLoading }),
  setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
  setCurrentPage: (currentPage) => set({ currentPage }),
  setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
  setSearchItem: (searchItem) => set({ searchItem }),
  setIsLoadingPage: (isLoadingPage) => set({ isLoadingPage }),
  setMinhasTarefas: (minhasTarefas) => set({ minhasTarefas }),
  setPaginations: (paginations) => set({ paginations }),
  setLastPage: (lastPage) => set({ lastPage }),
  setIsModalPegarTarefas: (isModalPegarTarefas) => set({ isModalPegarTarefas }),
  setIdRemessa: (idRemessa) => set({ idRemessa }),
  setTarefa: (tarefa) => set({ tarefa }),
}));
